import styles from './CardPedidosAtivos.module.css';
import ticket from '../../operador/styles/ticket.module.css';

function CardPedidosAtivos({ classe, horario, mesa, codigo, itens }) {
    const horarioFormatado = horario
        ? new Date(horario).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        : '--:--';

    return (
        <article className={styles[classe]}>
            <div className={styles.topo}>
                <span className={styles.codigo}>#{codigo}</span>
                <span className={styles.horario}>{horarioFormatado}</span>
            </div>
            <span className={styles.mesa}>{mesa ? `Mesa ${mesa}` : 'Balcão'}</span>

            <div className={`${styles.itens} ${ticket.ticketEdge}`}>
                {itens && itens.length > 0 ? (
                    itens.map((item) => {
                        const detalhe = item.detalhes?.find((d) => d.id_item === item.id_produto);
                        return (
                            <div key={item.id_item} className={styles.itemLinha}>
                                <span className={styles.itemQtd}>{item.quantidade}×</span>
                                <span className={styles.itemNome}>{detalhe?.nome_item || 'Item não disponível'}</span>
                            </div>
                        );
                    })
                ) : (
                    <span className={styles.semItens}>Sem itens registrados</span>
                )}
            </div>
        </article>
    );
}

export default CardPedidosAtivos;
